
import BadgeIcon from "../../../Icons/BadgeIcon";
import React, { useState } from "react";


function TweetHashtag({ entryjson, inputs, setInputs, saveMemberEntry }) {
    // const { showToast } = useToast();
    const entrydet = JSON.parse(entryjson.entry);
    const [nxtgoalbtn, setnxtgoalbtn] = useState('');


    const saveEntry = () => {
        saveMemberEntry();
    }

    const handleTweetClick = () => {
        setnxtgoalbtn(1);
    }

    function tweetUrl() {

        const curr_location = window.location.href;
        const tweet_make_url = "https://twitter.com/intent/tweet?hashtags=#" + entrydet?.tweet + "&text=&tw_p=&tweetbutton&url=" + curr_location
        const tweet_url = decodeURIComponent(tweet_make_url);
        return tweet_url;
    }


    return (
        <div className="cursor-default">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="md:w-[440px]">
                    <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 pb-1"> <p>{entrydet?.headline}</p></h4>
                    <div className=""> <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] pb-1">{entrydet?.description}</p></div>
                    <div className=""> <p className="font-medium text-[14px] leading-[22px] text-black opacity-100 pb-1">"{entrydet?.tweet}"</p></div>
                    {entrydet.describe_what &&
                        <div className="">
                            <p className="font-medium text-[14px] leading-[22px] text-black opacity-100 pb-1">{entrydet?.describe_what}</p>
                        </div>
                    }
                    <div className="">
                        <a href={tweetUrl()} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 font-semibold" onClick={handleTweetClick}>
                            {entrydet?.btn_text}
                        </a>
                    </div>
                </div>
                <div className="hidden min-[426px]:block">
                    <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <div className="pt-2">
                    <button onClick={(e) => { if (nxtgoalbtn === 1) { saveEntry(); } }} disabled={!nxtgoalbtn} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] ${!nxtgoalbtn ? 'opacity-50 cursor-not-allowed' : ' hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]'}`}>Earn Points</button>
                </div>
                <div className="pt-2">
                    <span class="earn_points_btn bg-white text-[#0274F7] ml-2 sm:hidden text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default TweetHashtag;